import { call, put, takeLatest } from 'redux-saga/effects';

import { captcha } from '../../services/API';

import { actionTypes, requestFailure, requestSuccess } from './actions';

function* getCaptcha(action) {
  const response = yield call(captcha, action.payload);

  if (response.isOk) {
    yield put(requestSuccess(response.data));
  } else {
    yield put(requestFailure(response.error));
  }
}

export default function* captchaSaga() {
  yield takeLatest(actionTypes.REQUEST_START, getCaptcha);
}
